'use client'
import React, { useState, useEffect } from "react";
import { useMemberstack } from "@memberstack/react";
import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
  Menu, MenuButton, MenuItem, MenuItems
} from '@headlessui/react'
import { Bars2Icon, ChatBubbleLeftIcon, ChevronRightIcon, HeartIcon } from '@heroicons/react/24/solid'
import { Link } from 'react-router-dom';
import Logo from './img/logo-clotere.svg'
import LogoMobile from './img/icn-logo-noir.svg'
import { PlusGrid, PlusGridItem, PlusGridRow } from './annuaire/Plus-grid'
import { PhoneIcon, UserIcon, ChevronDownIcon, BuildingOffice2Icon,  CurrencyEuroIcon, NewspaperIcon } from "@heroicons/react/20/solid";
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react'
import {CursorArrowRaysIcon} from '@heroicons/react/24/outline'
import { PopupButton } from '@typeform/embed-react';

const solutions = [
  { name: 'Vente immobilière', description: 'Trouvez votre notaire pour votre vente immobilière', href: '/notaire-vendeur', icon: BuildingOffice2Icon },
  { name: 'Achat immobilier', description: 'Protégez vos interêts d\'acheteur avec votre notaire', href: '/notaire-acheteur', icon: CursorArrowRaysIcon },
  { name: 'PMA', description: "Votre notaire pour vos démarches notariales de PMA", href: '/notaire-pma', icon: ChevronRightIcon },
  { name: 'Mariage', description: 'Sécurisez votre union avec un contrat de mariage', href: '/notaire-contrat-mariage', icon: HeartIcon },
  { name: 'Pacs', description: 'Votre convention de PACS par notaire', href: '/notaire-pacs', icon: HeartIcon }
]
const guides = [
  { name: 'Calculateur prix contrat de mariage', href: '/outils/calculateur-prix-contrat-mariage', icon: CurrencyEuroIcon },
  { name: 'Calculateur frais de notaire immobilier', href: '/outils/calculateur-frais-de-notaire-immobilier', icon: CurrencyEuroIcon },
  { name: 'Blog', href: '/blog', icon: NewspaperIcon },
  { name: 'Forum notaire', href: 'https://forum.clotere.fr/', icon: ChatBubbleLeftIcon }
]


function DesktopNav() {
  const memberstack = useMemberstack();
  const [member, setMember] = useState(null);

  useEffect(() => {
    if (member === null) {
      memberstack.getCurrentMember()
        .then(({ data: member }) => setMember(member))
    }
  }, []);

  return (
    <nav className="relative hidden lg:flex flex-2">
      <PlusGridItem className="relative flex items-center">
        <div 
        className={`p-2 no-underline flex items-center  text-base font-medium text-gray-950 bg-blend-multiply data-[hover]:bg-black/[2.5%]}`}
        >

          <Popover className="relative">
            <PopoverButton 
            className={`p-2 no-underline flex items-center  text-base font-medium text-gray-950 bg-blend-multiply data-[hover]:bg-black/[2.5%]}`}>
              <span>Démarches chez le notaire</span>
              <ChevronDownIcon aria-hidden="true" className="size-5" />
            </PopoverButton>

            <PopoverPanel
              transition
              className="absolute left-1/2 z-10 flex w-screen max-w-max -translate-x-1/2 px-4 transition data-closed:translate-y-1 data-closed:opacity-0 data-enter:duration-200 data-enter:ease-out data-leave:duration-150 data-leave:ease-in"
            >
              <div className="w-screen max-w-md flex-auto overflow-hidden rounded-3xl bg-white text-sm/6 ring-1 shadow-lg ring-gray-900/5">
                <div className="p-4">
                  {solutions.map((item) => (
                    <div key={item.name} className="group relative flex gap-x-6 rounded-lg p-2 hover:bg-gray-50">
                      <div className="mt-1 flex size-11 flex-none items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white">
                        <item.icon aria-hidden="true" className="size-6 text-gray-600 group-hover:text-indigo-600" />
                      </div>
                      <div className="text-left">
                        <Link to={item.href} className="font-semibold text-gray-900 no-underline">
                          {item.name}
                          <span className="absolute inset-0" />
                        </Link>
                        <p className="mt-1 text-gray-600">{item.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
                
              </div>
            </PopoverPanel>
          </Popover>
        </div>
        <div className="no-underline flex items-center p-2 text-base font-medium text-gray-950 bg-blend-multiply data-[hover]:bg-black/[2.5%]">
          <Popover className="relative">
            <PopoverButton className="no-underline flex items-center p-2 text-base font-medium text-gray-950 bg-blend-multiply data-[hover]:bg-black/[2.5%]">
              <span>Guides & Ressources</span>
              <ChevronDownIcon aria-hidden="true" className="size-5" />
            </PopoverButton>

            <PopoverPanel
              transition
              className="absolute left-1/2 z-10 flex w-screen max-w-max -translate-x-1/2 px-4 transition data-closed:translate-y-1 data-closed:opacity-0 data-enter:duration-200 data-enter:ease-out data-leave:duration-150 data-leave:ease-in"
            >
              <div className="w-screen max-w-md flex-auto overflow-hidden rounded-3xl bg-white text-sm/6 ring-1 shadow-lg ring-gray-900/5">
                <div className="p-4">
                  {guides.map((item) => (
                    <div key={item.name} className="group relative flex gap-x-6 rounded-lg p-2 hover:bg-gray-50 items-center">
                      <div className="mt-1 flex size-11 flex-none items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white">
                        <item.icon aria-hidden="true" className="size-6 text-gray-600 group-hover:text-indigo-600" />
                      </div>
                      <div>
                        <Link to={item.href} className="font-semibold text-gray-900 no-underline">
                          {item.name}
                          <span className="absolute inset-0" />
                        </Link>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </PopoverPanel>
          </Popover>
        </div>
        {!member &&
          <>
            <Link
              to="/connexion"
              className="no-underline flex items-center px-3 py-3 text-base font-medium text-gray-950 bg-blend-multiply data-[hover]:bg-black/[2.5%]"
            >
              Connexion
            </Link>
            <Link
              to="/onboard/empty"
              className="btn-main no-underline items-center hover:bg-gradient-to-r hover:from-teal-200 hover:to-teal-500"
            >
              Trouver mon notaire
            </Link>

          </>}

      </PlusGridItem>
      {member &&
        <>
          <Menu as="div" className="relative ml-3">
            <div>
              <MenuButton className="relative flex  text-grey-300 text-lg hidden sm:flex p-4">
                <span className="absolute" />
                <span className="sr-only">Ouvrir le menu client</span>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6 text-emerald-600">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z" />
                </svg>
                {member.auth.email}
              </MenuButton>
            </div>
            <MenuItems
              transition
              className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
            >
              <MenuItem>
                <Link to="/app/dashboard" className="no-underline block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100">
                  Tableau de bord
                </Link>
              </MenuItem>
              <MenuItem>
                <a className="no-underline block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100"
                  href="#"
                  onClick={() =>
                    memberstack.logout()
                      .then(({ data, type }) => {
                        window.location.replace('/');
                      })}
                >
                  Deconnexion
                </a>
              </MenuItem>
            </MenuItems>
          </Menu>
        </>
      }
    </nav>
  )
}


function MobileNavButton() {
  return (
    <>
      <div className="flex flex-row gap-2 items-center justify-end">
        <a href="tel:0757831364"
          className="border-1 border-slate-200  flex size-12 items-center justify-center self-center rounded-lg data-[hover]:bg-black/5 lg:hidden"
          aria-label="Appelez un conseiller Clotere"
        >
          <PhoneIcon className="size-6" />
        </a>
        <Link to="/connexion"
          className="border-1 border-slate-200  flex size-12 items-center justify-center self-center rounded-lg data-[hover]:bg-black/5 lg:hidden"
          aria-label="Appelez un conseiller Clotere"
        >
          <UserIcon className="size-6" />
        </Link>
        <DisclosureButton
          className="border-1 border-slate-200 flex size-12 items-center justify-center self-center rounded-lg data-[hover]:bg-black/5 lg:hidden"
          aria-label="Open main menu"
        >
          <Bars2Icon className="size-6" />
        </DisclosureButton>
      </div>

    </>
  )
}


{/** MENU MOBILE */}
function MobileNav() {
  const memberstack = useMemberstack();
  const [member, setMember] = useState(null);

  useEffect(() => {
    if (member === null) {
      memberstack.getCurrentMember()
        .then(({ data: member }) => setMember(member))
    }
  }, []);
  return (
    <DisclosurePanel className="lg:hidden bg-white rounded-lg border-slate-100">
      <div class="c_mobile-menu open"><div class="p-8">
        <div class="mb-6">
          <nav class="flex flex-col w-full gap-y-5">
          <div className="w-full justify-center no-underline flex items-center px-4 py-3 text-base font-medium text-gray-950 bg-blend-multiply data-[hover]:bg-black/[2.5%]">
          <Popover className="relative w-full justify-center ">
            <PopoverButton className="w-full justify-center no-underline flex items-center px-4 py-3 text-base font-medium text-gray-950 bg-blend-multiply data-[hover]:bg-black/[2.5%]">
              <span>Démarches chez le notaire</span>
              <ChevronDownIcon aria-hidden="true" className="size-5" />
            </PopoverButton>

            <PopoverPanel
              transition
              className="absolute left-1/2 z-10 flex w-screen max-w-max -translate-x-1/2 px-4 transition data-closed:translate-y-1 data-closed:opacity-0 data-enter:duration-200 data-enter:ease-out data-leave:duration-150 data-leave:ease-in"
            >
              <div className="w-screen max-w-md flex-auto overflow-hidden rounded-3xl bg-white text-sm/6 ring-1 shadow-lg ring-gray-900/5">
                <div className="p-4">
                  {solutions.map((item) => (
                    <div key={item.name} className="group relative flex gap-x-6 rounded-lg p-2 hover:bg-gray-50">
                      <div className="mt-1 flex size-11 flex-none items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white">
                        <item.icon aria-hidden="true" className="size-6 text-gray-600 group-hover:text-indigo-600" />
                      </div>
                      <div className="text-left">
                        <Link to={item.href} className="font-semibold text-gray-900 no-underline">
                          {item.name}
                          <span className="absolute inset-0" />
                        </Link>
                        <p className="mt-1 text-gray-600">{item.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="grid grid-cols-1 divide-x divide-gray-900/5 bg-gray-50 py-2">
                <p className="text-sm flex items-center justify-center  font-semibold text-gray-900 hover:bg-gray-100 mb-0">
                  Vous avez une question ?
                </p>
                <PopupButton
                                        id="cDphxVXu"
                                        size={100}
                                        autoClose={false}
                                        style={{ border: '0',margin:'0 auto' }}
                                        hidden={{ idnotaire: "empty"}}
                                    >
                                        <button className='btn-main no-underline bg-gradient-to-r from-indigo-300 to-indigo-800'>👋 Posez votre question à un notaire</button>
                                    </PopupButton>
                </div>
              </div>
            </PopoverPanel>
          </Popover>
        </div>

          <div className="justify-center w-[100%] no-underline flex items-center px-4 py-3 text-base font-medium text-gray-950 bg-blend-multiply data-[hover]:bg-black/[2.5%]">
          <Popover className="relative w-full">
            <PopoverButton className="w-full justify-center no-underline flex items-center px-4 py-3 text-base font-medium text-gray-950 bg-blend-multiply data-[hover]:bg-black/[2.5%]">
              <span>Guides & Ressources</span>
              <ChevronDownIcon aria-hidden="true" className="size-5" />
            </PopoverButton>

            <PopoverPanel
              transition
              className="w-full absolute left-1/2 z-10 flex  max-w-max -translate-x-1/2 px-4 transition data-closed:translate-y-1 data-closed:opacity-0 data-enter:duration-200 data-enter:ease-out data-leave:duration-150 data-leave:ease-in"
            >
              <div className="w-screen max-w-md flex-auto overflow-hidden rounded-3xl bg-white text-sm/6 ring-1 shadow-lg ring-gray-900/5">
                <div className="p-4">
                  {guides.map((item) => (
                    <div key={item.name} className="group relative flex gap-x-6 rounded-lg p-2 hover:bg-gray-50 items-center">
                      <div className="mt-1 flex size-11 flex-none items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white">
                        <item.icon aria-hidden="true" className="size-6 text-gray-600 group-hover:text-indigo-600" />
                      </div>
                      <div>
                        <Link to={item.href} className="font-semibold text-gray-900 no-underline">
                          {item.name}
                          <span className="absolute inset-0" />
                        </Link>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </PopoverPanel>
          </Popover>
        </div>
          </nav>
        </div>
        <div class="grid gap-y-4">
          <Link to="/connexion" class="no-underline font-medium transition-all inline-flex items-center justify-center disabled:bg-[#0000000D] disabled:cursor-not-allowed disabled:text-[#00000033] border-[1px] border-[#0000001A] hover:border-black hover:border-l-2 focus:bg-black focus:text-white px-7 py-[19.5px] text-lg h-md rounded-2xl relative" id="btn_menu_login" data-testid="btn_menu_login">Connexion</Link>
          <Link to="/onboard/empty" class="no-underline font-medium transition-all inline-flex items-center justify-center disabled:bg-[#0000000D] disabled:cursor-not-allowed disabled:text-[#00000033] text-white bg-black hover:bg-[#000000CC] px-7 py-[19.5px] text-lg h-md rounded-2xl relative" id="start_now_header" data-testid="start_now_header" type="button" aria-expanded="false">Trouver mon notaire</Link>
        </div>
      </div>
      </div>
      <div className="absolute left-1/2 w-screen -translate-x-1/2">
        <div className="absolute inset-x-0 top-0 border-t border-black/5" />
        <div className="absolute inset-x-0 top-2 border-t border-black/5" />
      </div>
    </DisclosurePanel>
  )
}

export function Navbar({ banner }) {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <div
    className={`sticky  transition-all duration-300 z-50 ${
      isScrolled ? "bg-white shadow-sm  top-0" : "bg-transparent"
    }`}
    >
    <div className="relative z-50">
      <div className="container">
        <Disclosure as="nav">
          <PlusGrid>
            <PlusGridRow className="relative flex justify-between">
              <div className="relative flex gap-6 flex-1">
                <PlusGridItem className="py-3">
                  <Link to="/" title="Home">
                    <img src={Logo} alt="clotere" 
                    className={` sm:flex hidden ${
                      isScrolled ? "h-6" : "h-8"
                    }`}
                     />
                    <img src={LogoMobile} alt="clotere" className="h-10 sm:hidden" />
                  </Link>
                </PlusGridItem>
                {banner && (
                  <div className="relative hidden items-center py-3 lg:flex">
                    {banner}
                  </div>
                )}
              </div>
              <DesktopNav />
              
              <MobileNavButton />
            </PlusGridRow>
          </PlusGrid>
          <MobileNav />
        </Disclosure>
      </div>
    </div>
    </div>
  )
}
